<div class="card-body">
    <div id="apex-simple-donut-chart"></div>
</div>